import { render, staticRenderFns } from "./ReviewEditorModal.vue?vue&type=template&id=c546dc7c&scoped=true"
import script from "./ReviewEditorModal.vue?vue&type=script&lang=js"
export * from "./ReviewEditorModal.vue?vue&type=script&lang=js"
import style0 from "./ReviewEditorModal.vue?vue&type=style&index=0&id=c546dc7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c546dc7c",
  null
  
)

export default component.exports